/**
 * Step2 表格内联编辑：字符串字段与历史数组的展示互转（不做 JSON 解析入库）。
 */
import type { IYamlFieldColumn } from '../../types';

/**
 * 「示例值」输入框展示：字符串原样；历史数组数据仅序列化供编辑。
 */
export const sampleValuesText = (col: IYamlFieldColumn): string => {
  if (typeof col.default_sample_values === 'string') {
    return col.default_sample_values;
  }
  if (Array.isArray(col.default_sample_values)) {
    return JSON.stringify(col.default_sample_values);
  }
  return '';
};

/**
 * 「筛选条件」输入框展示：字符串原样；历史数组数据仅序列化供编辑。
 */
export const filtersText = (col: IYamlFieldColumn): string => {
  if (typeof col.filters_text === 'string') {
    return col.filters_text;
  }
  if (Array.isArray(col.filters)) {
    return JSON.stringify(col.filters);
  }
  return '';
};
